
// frontend/src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Bootstrap utilities (optional)
import "bootstrap/dist/css/bootstrap.min.css";

// Global theme (replace index.css with the site.css provided earlier)
import "./styles/base.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Keep or remove depending on whether you need performance metrics
reportWebVitals();
